import { render, staticRenderFns } from "./SideBarExample.vue?vue&type=template&id=069f1eb0&scoped=true&"
import script from "./SideBarExample.vue?vue&type=script&lang=js&"
export * from "./SideBarExample.vue?vue&type=script&lang=js&"
import style0 from "./SideBarExample.vue?vue&type=style&index=0&id=069f1eb0&scoped=true&lang=scss&"
import style1 from "./SideBarExample.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069f1eb0",
  null
  
)

export default component.exports